<template>
    <div>
        <label v-if="label">{{ labelText || 'Função' }}</label>
        <a-select size="large"  v-model="selectedOption" style="width: 100%;" @change="(value) => $emit('change', value)">
            <a-select-option v-for="emp in employeeRoles" :key="emp.value" :value="emp.value">
                {{ emp.label }}
            </a-select-option>
        </a-select>
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    import employeeRoles from '@/components/account/employeeRoles.js'

    export default {
        props : {
            default : {
                type : Number,
                required : false,
            },
            label : {
                type: Boolean,
                required : true
            },
            labelText : {
                type: String,
                required : false
            },
            disabled : {
                type: Boolean,
                required : false
            }
        },

        components : {
            'v-select': vSelect,
        },

        mounted () {
            this.employeeRoles = employeeRoles.availableEmployeeRoles()
            if(this.default != null) this.selectedOption = this.default; else this.selectedOption = 2
        },

        data () {
            return {
                selectedOption : 1,
                employeeRoles : []
            }
        },
    }
</script>